var _Defs, _Use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, Symbol as _Symbol, Circle, Path, Use } from "react-native-svg";
function SvgSunny(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "sunny_svg__a",
    x1: 149.99,
    y1: 119.24,
    x2: 234.01,
    y2: 264.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "sunny_svg__b",
    viewBox: "0 0 384 384"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 192,
    cy: 192,
    r: 84,
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    fill: "url(#sunny_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M192 61.66V12m0 360v-49.66m92.17-222.51l35.11-35.11M64.72 319.28l35.11-35.11m0-184.34L64.72 64.72m254.56 254.56l-35.11-35.11M61.66 192H12m360 0h-49.66",
    fill: "#fff",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24
  })))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 384,
    height: 384,
    transform: "translate(64 64)",
    xlinkHref: "#sunny_svg__b"
  })));
}
export default SvgSunny;